module.exports = __webpack_public_path__ + "05_face.edd5b274.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer1/05_face.png
// module id = aOWY
// module chunks = 0